import { isEmpty } from 'lodash'

import type { ApiClient } from './client'
import { makeApiClient } from './index'
import { useAppointmentStore } from '~/terminierungsportal/stores/appointment'

const appointmentIdToApiMap = new Map<string, ApiClient>()

export const useApi = (): ApiClient => {
  const appointmentStore = useAppointmentStore()
  const appointmentId = appointmentStore.appointmentId
  if (isEmpty(appointmentId)) {
    throw new Error('[useApi] Missing required appointment id')
  }

  let apiClient = appointmentIdToApiMap.get(appointmentId)

  if (!apiClient) {
    appointmentIdToApiMap.set(appointmentId, (apiClient = makeApiClient()))
  }

  return apiClient
}
